import React from 'react';
import {
  AppBar as MuiAppBar,
  AppBarProps,
  styled,
  Toolbar,
  IconButton,
  Box,
} from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';

interface CustomAppBarProps extends AppBarProps {
  open?: boolean;
  toggleDarkMode?: () => void;
  isDarkMode?: boolean;
}

const drawerWidth = 240;

const StyledAppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<CustomAppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: '#1c2e4a',
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const AppBar: React.FC<CustomAppBarProps> = ({ open, toggleDarkMode, isDarkMode, children, ...props }) => {
  return (
    <StyledAppBar position="absolute" open={open} {...props}>
      <Toolbar>
        {/* Esquerda: título e ícones */}
        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
          {children}
        </Box>

        {/* Direita: botão de dark mode */}
        <IconButton
          color="inherit"
          onClick={toggleDarkMode}
          aria-label="Alternar entre modo claro e escuro"
        >
          {isDarkMode ? <Brightness7 /> : <Brightness4 />}
        </IconButton>
      </Toolbar>
    </StyledAppBar>
  );
};

export default AppBar;
